export default {
  en: {
    webinarCard: {
      externalLink: 'External Link',
      viewDetails: 'View Details'
    },
    casesCard: {
      introduction: 'Introduction Service & Product'
    },
    productCard: {
      quickView: 'QuickView'
    },
    compoundCard: {
      compound: 'Compound',
      application: 'CoreFocus Report',
      field: 'Field',
      column: 'Column',
      productPage: 'Product Page',
      instruments: 'Instruments',
      pN: 'P/N',
      productType: 'Product Type'
    }
  },
  ja: {
    webinarCard: {
      externalLink: '外部リンク',
      viewDetails: '詳細を表示'
    },
    casesCard: {
      introduction: 'サービス・製品'
    },
    productCard: {
      quickView: 'QuickView'
    }
  },
  'zh-hant': {
    webinarCard: {
      externalLink: '外部連結',
      viewDetails: '詳情請見'
    },
    casesCard: {
      introduction: 'Introduction Service & Product'
    },
    productCard: {
      quickView: '快速檢閱'
    }
  },
  es: {
    webinarCard: {
      externalLink: 'Enlace externo',
      viewDetails: 'Ver detalles'
    },
    casesCard: {
      introduction: 'Introducción Servicio & Producto'
    },
    productCard: {
      quickView: 'Vista rápida'
    },
    compoundCard: {
      compound: 'Compuesto',
      application: 'Informe CoreFocus',
      field: 'Campo',
      column: 'Columna',
      productPage: 'Página del producto',
      instruments: 'Instrumentos',
      pN: 'P/N'
    }
  },
  'pt-br': {
    webinarCard: {
      externalLink: 'Link externo',
      viewDetails: 'Ver detalhes'
    },
    casesCard: {
      introduction: 'Introdução aos serviços e Produtos'
    },
    productCard: {
      quickView: 'Visualização rápida'
    },
    compoundCard: {
      compound: 'Composto',
      application: 'Relatório CoreFocus',
      field: 'Campo',
      column: 'Coluna',
      productPage: 'Página do produto',
      instruments: 'Instrumentos',
      pN: 'P/N'
    }
  }
}
